import { useParams } from 'react-router-dom';
import DetailsArbre from '@repo/ui/features/inventaires/details-inventaire/index-type-router';

export default function ArbreDetailsPage() {
  const { id = '' } = useParams<{ id?: string }>();

  return (
    <div className="w-full py-6">
      <DetailsArbre inventaireId={Number(id)} type="ARBRE" />
    </div>
  );
}

